export enum Player {
    white = 0,
    black = 1
}
